import $ from 'jquery';
import * as rt from "@common/AppRT";

let DownloadingIframe: any = null;

function Alert(data: string)
{
    alert(data);
}

function ReplaceUrl(url: string)
{
    //redirect with working browser back button
    window.location.replace(url);
}

function ChangeHash(hash: string)
{
    if (hash == window.location.hash.replace("#", ""))
    {
        window.location.hash = "#/?";
        const handle = setTimeout(() => { window.location.hash = hash; clearTimeout(handle); }, 10);
    }
    else
    {
        window.location.hash = hash;
    }
}

function NavigateToUrl(url: string)
{
    window.location.href = url;
}

export function Refresh()
{
    window.location.reload();
}


export function DownloadBlob(url: string)
{
    if ($("#DownloadingIframe").length > 0)
    {
        DownloadingIframe.remove();
    }

    DownloadingIframe = $('<iframe />').attr('src', url).hide().appendTo('body');
}

const actions: { [propName: string]: any } = {
    Alert: Alert,
    ChangeHash: ChangeHash,
    NavigateToUrl: NavigateToUrl,
    ReplaceUrl: ReplaceUrl,
    DownloadBlob: DownloadBlob,
    Refresh: Refresh,
}

rt.subscribeModule("Browser", actions);